import { useState } from 'react'
import { useTrocarPropriaSenha } from '../../api/queries/usuarios'
import { Botao } from '../../components/Botao'
import { AvisoDeErro } from '../../components/Estados'
import { Cartao } from '../../components/ListaDeDados'
import { CampoDeTexto } from '../../components/campos'
import { TEXTOS } from '../../lib/glossario'

/**
 * A troca de senha voluntária, dentro de "Minha conta".
 *
 * É o mesmo endpoint da troca obrigatória do primeiro acesso — e de propósito: um segundo caminho
 * de troca de senha é um segundo lugar onde esquecer de exigir a senha atual. A diferença é só a
 * moldura: lá a tela substitui o sistema inteiro e não dá para sair; aqui é um cartão entre outros,
 * e o sucesso precisa dizer que aconteceu, porque nada muda de lugar depois de salvar.
 *
 * O aviso sobre o sistema anterior está aqui por um risco real de perda de acesso: são duas contas
 * diferentes, e quem trocar a senha achando que trocou a de lá vai continuar entrando com a antiga
 * — ou pior, vai concluir que "o sistema não salvou".
 *
 * @returns o cartão de troca de senha
 */
export function TrocaDeSenha() {
  const trocar = useTrocarPropriaSenha()
  const [senhaAtual, setSenhaAtual] = useState('')
  const [novaSenha, setNovaSenha] = useState('')
  const [confirmacao, setConfirmacao] = useState('')
  const [trocada, setTrocada] = useState(false)
  const t = TEXTOS.usuarios.trocaObrigatoria

  const naoConfere = confirmacao !== '' && confirmacao !== novaSenha
  const incompleto = !senhaAtual || !novaSenha || !confirmacao

  async function salvar() {
    if (naoConfere || incompleto) {
      return
    }
    try {
      await trocar.mutateAsync({ senhaAtual, novaSenha })
      setTrocada(true)
      setSenhaAtual('')
      setNovaSenha('')
      setConfirmacao('')
    } catch {
      // O AvisoDeErro abaixo diz o que o servidor recusou e por quê.
    }
  }

  return (
    <Cartao titulo={TEXTOS.perfil.trocarSenha} descricao={TEXTOS.perfil.trocarSenhaAjuda}>
      <div className="max-w-md space-y-4">
        <CampoDeTexto
          rotulo={t.senhaAtual}
          ajuda={t.senhaAtualAjuda}
          type="password"
          autoComplete="current-password"
          value={senhaAtual}
          onChange={(e) => {
            setSenhaAtual(e.target.value)
            setTrocada(false)
          }}
        />
        <CampoDeTexto
          rotulo={t.novaSenha}
          ajuda={t.novaSenhaAjuda}
          type="password"
          autoComplete="new-password"
          value={novaSenha}
          onChange={(e) => setNovaSenha(e.target.value)}
        />
        <CampoDeTexto
          rotulo={t.confirmar}
          erro={naoConfere ? t.naoConfere : undefined}
          type="password"
          autoComplete="new-password"
          value={confirmacao}
          onChange={(e) => setConfirmacao(e.target.value)}
        />

        {trocar.isError && <AvisoDeErro erro={trocar.error} titulo={t.naoTrocou} />}

        {trocada && (
          <p role="status" className="rounded-lg bg-emerald-50 px-3 py-2 text-sm text-emerald-800">
            {TEXTOS.perfil.senhaTrocada}
          </p>
        )}

        <Botao aparencia="primario" onClick={salvar} disabled={trocar.isPending || naoConfere || incompleto}>
          {trocar.isPending ? 'Salvando…' : t.salvar}
        </Botao>
      </div>
    </Cartao>
  )
}
